export default "__VITE_ASSET__onnQP7Ex__"